import { CTA, CTAProps, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TrackingForm, useTrackingManager } from 'src/feature-app';
import { RenderController } from 'src/feature-app/Screen';
import { OneFormState } from 'src/types';
import styled from 'styled-components';
import { globalStyles } from './styles';

const ThankYouWrapper = styled.div`
	width: 100%;
	text-align: center;
	img {
		display: block !important;
		width: 100%;
		margin-bottom: 44px;
	}
`;
const RedirectCTA = styled(CTA)<CTAProps>`
	margin-top: 30px;
	background: var(--c-red) !important;
	color: var(--c-white) !important;
	&:hover:not(:disabled),
	&:active:not(:disabled),
	&:focus:not(:disabled):not(:focus-visible) {
		background: rgb(165, 0, 13) !important;
	}
`;

export function NavidadGTI2025ThankYou() {
	const { formInfo } = useSelector((state: OneFormState) => state);
	const trackingManager = useTrackingManager();
	const dispatch = useDispatch();
	const getTrackingForm = (): TrackingForm => ({
		LeadID: undefined,
		FormFields: undefined,
	});

	useEffect(() => {
		// Thank you page no es gestionado como un step pero sí lo haremos en la analítica. Por eso Modificamos formInfo después del submit y antes del RESET
		const screenIndexThankyou = formInfo?.numberOfScreens;

		dispatch({ type: 'SET_FORM_SUBMITTED', payload: true });
		dispatch({
			type: 'SET_FORM_INFO',
			payload: { step: { screenIndex: screenIndexThankyou, name: 'ThankYou' } },
		});

		trackingManager.trackFormSubmissionSuccessMessageLoad(
			{
				contentId: undefined,
			},
			getTrackingForm(),
		);
	}, []);

	useLayoutEffect(() => {
		globalStyles();
		
		return () => {
			const style = document.getElementById('oneform-gti50-style');
			if (style) {
				style.remove();
			}
		};
	}), [];

	const screen = (
		<ThankYouWrapper className="thank-you-wrapper">
			<div>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					Pronto tendrás carbón en tu bandeja de entrada
				</Text>
			</div>
			<RedirectCTA
				tag="button"
				type="submit"
				emphasis="primary"
				onClick={(e) => {
					e.preventDefault();

					const { protocol, host, pathname, search } = window.location;
					const base = `${protocol}//${host}${pathname}`;

					const params = new URLSearchParams(search);
					params.set('scrollTo', 'anchorEndForm');

					const newUrl = `${base}?${params.toString()}`;

					window.location.replace(newUrl);
				}}
			>
				Descubre a quién agradecérselo
			</RedirectCTA>
		</ThankYouWrapper>
	);

	return <RenderController screenType="full-screen" title={screen} fields={<></>} key={555} avoidTrackFormStepLoad thankYouPage />;
}
